import { getUrlOrigin } from '@monoimin/utils/helpers';

import { Locales } from '@monoimin/sb-types';

interface GetBreadcrumbsUrlParams {
  pathname: string;
  locale: Locales;
  basePath?: string;
  site?: MiniSlug;
}

export const getBreadcrumbsUrl = ({
  basePath = '/',
  locale,
  pathname,
  site,
}: GetBreadcrumbsUrlParams): string => {
  const origin = getUrlOrigin(locale, site);
  if (basePath === '/') {
    return `${origin}${pathname}`;
  }
  return `${origin}${basePath}${pathname}`;
};
